/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleCompactViewAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ToggleCompactViewAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/ToggleCompactViewAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<button
  data-testid="ToggleCompactViewAction.Vertical"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../../../Events/Content/Content/Content/Content/Events/Content/Compact')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Events/Content/Content/Content/Content/Events/Content/Timeline')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Events/Content/Content/Content/Content/Events/Content/Compact'))}
 className={`views-block ${styles.Vertical}`}
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style={flow.has(fromFlow.normalizePath(viewPath, '../../../Events/Content/Content/Content/Content/Events/Content/Compact')) ? "filled" : "outline"}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Compact"
/>
)}
</TysiaTag>
</button>
{children}
</React.Fragment>)
}